(function() {
	/**
	 * @exports DKA.controllers.home
	 * @requires HBS
	 */
	let module = {};

	module.init = () => {
	};

	var docReady = function docReady(callback) {
	// in case the document is already rendered
		if (document.readyState !== 'loading') {
			callback();
		} else if (document.addEventListener) {
			// modern browsers
			document.addEventListener('DOMContentLoaded', callback);
		} else {
			// IE <= 8
			document.attachEvent('onreadystatechange', function () {
				if (document.readyState === 'complete') callback();
			});
		}
	};

	docReady(function () {
		HBS.initPage();
	});

	HBS.namespace('DKA.controllers.verticals', module);
}());